import { getSessionForAccessInfo, checkGraphResponse } from "./GraphMain";
import { driveItemInfoType, accessInfoType } from "../utils/classInfos";
import { getElementAppInfo } from "./graphAppInfoElementFunctions";
import { getHelperTables, getWorksheetIdFromAddress, getWorksheetUrlSection } from "./helper";
import { getLocalCellNameFromAddress } from "../utils/helperExcel";
import { optimizeNameList } from "./names";

export async function getRangeInfo(
  accessInfo: accessInfoType,
  rangeId: string,
) {
  const sessionInfo  = await getSessionForAccessInfo(accessInfo);
  // check the info
  if (!sessionInfo || !sessionInfo.sessionId) return null;
  const {client, sessionId, fileUrl} = sessionInfo;
  
  const nameUrl = fileUrl + "/workbook/names/"+rangeId;
  const rangeUrl = nameUrl + "/range?$select=values,text,formulas,numberFormat,cellCount,rowCount,address"; //worksheetId,valueTypes
  
  const $batch = {
    requests: [
      {
        url: nameUrl,
        method: "GET",
        id: "NAMES",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: rangeUrl,
        method: "GET",
        id: "RANGE",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: fileUrl + "/workbook/worksheets?$select=name,id",
        method: "GET",
        id: "WORKSHEETS",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: fileUrl + "/workbook/tables?$select=name",
        method: "GET",
        id: "TABLES",
        headers: {
          "workbook-session-id": sessionId
        }
      },
    ],
  };
  // RUN BATCH
  let res = await client
    .api("/$batch")
    .post($batch);

  checkGraphResponse(res, "getRangeInfo");  
  
  // RESULTS
  let range = res.responses[res.responses.findIndex((x) => x.id === "RANGE")]?.body;
  let nameInfo = res.responses[res.responses.findIndex((x) => x.id === "NAMES")]?.body;
  let tableTables = res.responses[res.responses.findIndex((x) => x.id === "TABLES")]?.body;
  let workSheets = res.responses[res.responses.findIndex((x) => x.id === "WORKSHEETS")]?.body;
  // let rangeAddress = "";
  // get the worksheetId for the range
  if (range) {
    range.worksheetId = getWorksheetIdFromAddress(nameInfo?.value, workSheets?.value);
    // rangeAddress = range.address;
  }
  // if (rangeAddress && range.worksheetId) {
  //   // get the format
  //   const formatUrl = fileUrl + "/workbook/worksheets('"+range.worksheetId+"')/range(address='"+rangeAddress+"')/format/fill";
  //   // api call
  //   const resFormat = await client
  //     .api(formatUrl)
  //     .header("workbook-session-id", sessionId)
  //     .get();
  // }
  // helper tables
  const helperTables = getHelperTables(tableTables?.value);
  const hasHelperTables = helperTables.length > 0;
  // get the app info
  let appInfo = await getElementAppInfo(accessInfo, rangeId, "range", sessionId, fileUrl, client, helperTables);

  return { nameId: rangeId, nameInfo, range, appInfo, accessInfo, hasHelperTables, helperTables };
}

export async function createNewRange(
  accessInfo: any,
  rangeId: string,
  rangeCaption: string,
  rangeAddress: string
) {
  const {client, sessionId, fileUrl} = await getSessionForAccessInfo(accessInfo);
  const nameListUrl = fileUrl + "/workbook/names"; //?$select=name,value,comment";
  let workbookNamedItem;
  // create a new name
  try {
    const newNameUrl = fileUrl + "/workbook/names/add";
    workbookNamedItem = {
      name: rangeId,
      reference: rangeAddress,
      comment: rangeCaption
    };
    // api call
    await client
      .api(newNameUrl)
      .header("workbook-session-id", sessionId)
      .post(workbookNamedItem);
  } catch (err) {
    console.log("ERROR new Name", err, workbookNamedItem);
    return null;
  }
  // get the new names list
  let names: any;
  try {
    const rawNames = await client
      .api(nameListUrl)
      .header("workbook-session-id", sessionId)
      .get();
    names = optimizeNameList(rawNames.value);
  } catch (err) { 
    console.log("ERROR getting names", err);
  }
  return names;
}

export async function deleteRange(
  driveItemInfo: driveItemInfoType,
  rangeId: string
) {
  alert("Actually you need to remove the named range manually from your Excel workbook! We apologize for any inconvenience. The name is called: " + rangeId);
  // const fileUrl = getFileUrlFromDriveInfo(driveItemInfo);
  // const sessionId = await getSessionIdFromDriveInfo(driveItemInfo);
  // const nameListUrl = fileUrl + "/workbook/names";
  // // delete name
  // try {
  //   const deleteNameUrl = fileUrl + "/workbook/names/add";
  //   const workbookNamedItem = {
  //     name: nameId,
  //     reference: nameRange,
  //     comment: nameCaption
  //   };
  //   // api call
  //   await client
  //     .api(deleteNameUrl)
  //     .header("workbook-session-id", sessionId)
  //     .post(workbookNamedItem);
  // } catch (err) { 
  //   console.log("ERROR new Name", err);
  // }
  // return;
}

export async function getNamesValueBatch(
  fileUrl: string,
  sessionId: string,
  client: any,
  names: any[],
) {
  const maxBatchCount = 18;
  let tempRequests = [];

  names.forEach(nameItem => {
    const worksheetId = nameItem.worksheetId ?? nameItem.worksheet;
    if (nameItem.isCell === true) {
      if (tempRequests.length <= maxBatchCount) {
        const tempAddress = getLocalCellNameFromAddress(nameItem.value);
        const tempUrl = fileUrl + "/workbook/" + getWorksheetUrlSection(worksheetId) + "/range(address='"+tempAddress+"')?$select=values,formulas,numberFormat,text";
        // title request
        tempRequests.push({
          url: tempUrl,
          method: "GET",
          id: nameItem.id,
          headers: {
            "workbook-session-id": sessionId
          }
        });
      }
    }
  })

  let res = null;
  if (tempRequests.length > 0) {
    const $batch = {
      requests: tempRequests,
    };

    res = await client
      .api("/$batch")
      .post($batch);

    checkGraphResponse(res, "getNamesValueBatch");  
  }

  // get the range detail

  names.forEach(nameItem => {
    try {
      let tempValue = null;
      if (res) {
        tempValue =
          res.responses[
            res.responses.findIndex((x) => x.id === nameItem.id)
          ];
      }
      let cellValue = undefined;
      if (tempValue?.body.hasOwnProperty('text')) {
        cellValue = tempValue?.body?.text[0][0];
      }
      nameItem.cellValue = cellValue;
      nameItem.propertiesLoaded = nameItem.needToUpgrade || (cellValue?.length > 0);
    } catch (err) {
      console.log("ERROR response", err);
    }
  })

  return {
    items: names,
  };
}
